// extracted by mini-css-extract-plugin
export default {"container":"CancelActions_container__idrxb","header":"CancelActions_header__G+Tfw","cancel":"CancelActions_cancel__s+Slk","hint":"CancelActions_hint__jCzeD"};